import React from "react";
import Framework from "@beardeddevops/react.framework";
import {Types} from "components";
import {Button} from "reactstrap";
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardActions from '@material-ui/core/CardActions';
import {confirmAlert} from "react-confirm-alert";
import API from "@beardeddevops/react.api";
import {Link} from "react-router-dom";

/**
 *  @property {Tickets_Financials_Object} state
 *  @property {object} model
 *  @property {Tickets_Financials_Properties} model.properties
 *  @property {Tickets_Financials_Is} model.is
 *  @property {Tickets_Financials_Has} model.has

 */
export default class Financial extends Framework.Components.Object {
	constructor(props) {
		super(props, Types.Tickets_Financials._name);
		this.state.ticket = this.props.parent;
		if (!this.props.hideBack) {
			this.redirect = this.props.baseUrl;
		}
	}

	handleSubmit = async (event, suppressToast = false) => {
		try {
			await super.handleSubmit(event, suppressToast);
			if (this.props.hideBack && typeof this.props.reloadPage === "function") {
				this.props.reloadPage();
			}
		} catch (error) {
			// Keep modal open when save fails.
		}
	};

	handleCancel = () => {
		if (typeof this.props.reportClose === "function") {
			this.props.reportClose();
			return;
		}
		if (typeof this.props.closeModal === "function") {
			this.props.closeModal();
			return;
		}
		if (typeof this.props.reloadPage === "function") {
			this.props.reloadPage();
		}
	};

	componentDidUpdate(prevProps, prevState, snapshot) {
		super.componentDidUpdate(prevProps, prevState, snapshot);
		if (typeof this.props.updateName === 'function') {
			this.props.updateName(this.state.name);
		}
	}

	loadSelfAfter() {
		super.loadSelfAfter();
		if (typeof(this.props.setManagerOverride) === 'function' && this.state.manager_override_approver) {
			this.props.setManagerOverride(this.state.manager_override_approver)
		}
	}

	approve = () => {
		const pkey = this.state.pkey

		confirmAlert({
			title: 'Confirm Approval',
			message: 'Are you sure you want to approve this ticket financial information?',
			buttons: [
				{
					label: 'Yes',
					color: 'danger',
					onClick: async () => {
						let model = new API.BuildClass(Types.Tickets_Financials._name, API.RequestType.UPDATE);
						this.update = 'POST_APPROVE';
						model.object.pkey = pkey;
						try {
							await model.submit(null, this.update);
						} catch (error) {
						}
						model.object.pkey = '';
						this.props.reloadPage();

					}
				},
				{
					label: 'No',
					onClick: () => {
					}
				}
			]
		});
	}

	render() {
		/**
		 * @param {Tickets_Financials_Properties} data
		 */
		let {properties} = this.model
		/**
		 * @type {Tickets_Financials_Object} object
		 */
		let object = this.state
		let {loading} = this.state

		return (
			<div className="row">
				<div className="col-12">
					<Card>
						<CardContent>
							<h4 className="section-title">Financial</h4>
							<fieldset>
								<div className={"form-group"}>
									<Framework.Elements.Select
										shouldLoad={true}
										label={"Payment Type"}
										property={properties.payment_type}
										value={object.payment_type}
										error={object.payment_type_error}
										update={this.handleSelectPropertyUpdate}
										text={"name"}
									/>
								</div>
								<div className={"form-group"}>
									<Framework.Elements.TextField
										label={"Labor Amount"}
										value={object.labor_amount}
										error={object.labor_amount_error}
										property={properties.labor_amount}
										update={this.handleTextFieldPropertyUpdate}
									/>
								</div>
								<div className={"form-group"}>
									<Framework.Elements.TextField
										label={"Expected Labor Amount"}
										value={object.expected_labor}
										error={object.expected_labor_error}
										property={properties.expected_labor}
										update={this.handleTextFieldPropertyUpdate}
										disabled={true}
									/>
								</div>
								<div className={"form-group"}>
									<Framework.Elements.TextField
										label={" Anti Virus Sales"}
										value={object.virus_sales}
										error={object.virus_sales_error}
										property={properties.virus_sales}
										update={this.handleTextFieldPropertyUpdate}
									/>
								</div>
								<div className={"form-group"}>
									<Framework.Elements.TextField
										label={"Parts Amount"}
										value={object.parts_amount}
										error={object.parts_amount_error}
										property={properties.parts_amount}
										update={this.handleTextFieldPropertyUpdate}
									/>
								</div>
								<div className={"form-group"}>
									<Framework.Elements.TextField
										label={"Notes"}
										value={object.notes}
										error={object.notes_error}
										property={properties.notes}
										update={this.handleTextFieldPropertyUpdate}
										multiline={true}
									/>
								</div>
							</fieldset>
							<Framework.Elements.LoadingSpinner isLoading={loading}/>
						</CardContent>
						<CardActions style={{display: "flex", justifyContent: "flex-end", gap: "8px"}}>
							{this.props.hideBack ? (
								<>
									<Button color="secondary" onClick={this.handleCancel}>
										Cancel
									</Button>
									{this.props.baseUrl !== "/financial" && (
										<Button color="primary" onClick={this.handleSubmit}>
											Save
										</Button>
									)}
								</>
							) : (
								<>
									<Link to={"/financial"}>
										<Button color="secondary">Back</Button>
									</Link>
									{this.props.baseUrl !== "/financial" ? (
										<Button color="primary" onClick={this.handleSubmit}>Save</Button>
									) : (
										<div>{
											!object.approved ?
												<Button color={"secondary"} onClick={this.approve}>
													<i className={"fa fa-exclamation"}/>&nbsp;&nbsp;Approve
												</Button>
												: <Button color={"primary"}>
													<i className={"fa fa-check"}/>&nbsp;&nbsp;Approved
												</Button>
										}
										</div>
									)}
								</>
							)}
						</CardActions>
					</Card>
				</div>
				{/*<div className="col-6">*/}
				{/*	<Card>*/}
				{/*		<CardContent>*/}
				{/*			<h4 className="section-title">Deposit Image</h4>*/}
				{/*			{!this.props.financial ?*/}
				{/*				<div className={"col-6"}>*/}
				{/*					<p>*/}
				{/*						Upload a copy of the deposit here for future reference and verification.<br/>*/}
				{/*						{object.image ?*/}
				{/*							<span>Current Image - <b>{object.image}</b><br/><i>Upload a new file to replace the old one, then click*/}
				{/*								Save. It will be displayed next time you come back.</i></span> : null*/}
				{/*						}*/}
				{/*					</p>*/}
				{/*					<Framework.Elements.DropZone*/}
				{/*						property={properties.image}*/}
				{/*						value={object.image}*/}
				{/*						error={object.image_error}*/}
				{/*						update={this.handleFileChange}/>*/}
				{/*				</div> :*/}
				{/*				<div className={"col-6"}>*/}
				{/*					<p>*/}
				{/*						Any images attached to the ticket will appear here.<br/>*/}
				{/*						{object.image ?*/}
				{/*							<span>Current Image - <b>{object.image}</b><br/></span> : null*/}
				{/*						}*/}
				{/*					</p>*/}
				{/*				</div>}*/}
				{/*			{object.image && <div>*/}
				{/*				<img*/}
				{/*					src={APPCONFIG.settings.apiURL() + '/' + APPCONFIG.settings.apiVersion + '/tickets/' + object.ticket + '/financials/images?image=' + object.image.split('.')[0]}*/}
				{/*					alt={object.image}*/}
				{/*					style={{maxWidth: '100%'}}*/}
				{/*				/>*/}
				{/*			</div>}*/}
				{/*		</CardContent>*/}
				{/*	</Card>*/}
				{/*</div>*/}
			</div>
		)
	}
}
